<template>
  <div>
    <div class="section-header">
      <h1>My goals</h1>
      <div>
        <button class="row align-center" @click="editGoal=true">
          <i class="material-icons">add</i>
          New Goal
        </button>
      </div>
    </div>
    <div class="small-top" v-for="goal in goals" :key="goal.id"> 
      <goal-card :goal="goal"  @remove="remove(goal)" @complete="complete(goal)">
      </goal-card>
    </div>
    <div class="card card--transparent" v-if="!loadingGoals && goals.length === 0">
      <div class="card--container">
        Goals are an important part of self-improvement and growth. They provide direction for your efforts and keep you focused on what matters most. When you make goals and continually try to reach those goals, you achieve more strength, resilience, pride, and success.
      </div>
    </div>
    <goal-modal :goal="selectedGoal" v-if="editGoal" @close="editGoal=false" @saved="addGoal">
    </goal-modal>

    <div class="section-header">
      <h1>KPIs</h1>
      <div class="row space-between">
        <button @click="displayAddKPI=true" class="align-center" style="margin-right: 15px"><h-icon>add</h-icon> Add</button>
        <button @click="displayEditKPI=true" class="align-center"><h-icon>edit</h-icon> Edit</button>
      </div>
    </div>
    <kpi :kpi="kpi" v-for="kpi in kpis" :key="kpi.id"/>
    <div class="card card--transparent" v-if="!loadingKpi && kpis.length == 0">
      <div class="card--container">
        Key Performance Indicators (KPIs) allow you to track important metrics over time and measure your progress. You can use KPIs to measure your progress toward a goal and discover the impact of your habits over time. When you combine your daily reflections and pulses with KPIs, you will discover patterns in your successes and failures.  This self-awareness will be a valuable tool in self-improvement.
      </div>
    </div>
    <add-kpi @created="refreshKPI" @close="displayAddKPI = false" v-if="displayAddKPI"/>
    <edit-kpis @destroy="destroyKPI" :kpis="kpis" @save="refreshKPI" @close="displayEditKPI = false" v-if="displayEditKPI" />
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import moment from "moment";
import snackbar from "@/services/hubs/snackbar";
import goalModal from "@/components/goals/goalModal";
import goalCard from "@/components/goals";
import kpiChart from "@/components/kpiChart";
import axios from "axios";
import addKpi from "./kpis/add";
import editKpis from "./kpis/editKPI";

// TODO: Add a component to encapsoluate kpis (duplicated in progress)
export default {
  components: { goalModal, goalCard, kpi: kpiChart, addKpi, editKpis },
  data() {
    return {
      displayAddKPI: false,
      displayEditKPI: false,
      selectedGoal: { milestones: [], color: "" },
      editGoal: false,
      goals: [],
      kpis: [],
      loadingKpi: true,
      loadingGoals: true,
      small: Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 600
    };
  },
  created() {
    this.refreshKPI();
    dataStore.findAll("ClientGoals", {limit: 500}, { force: true })
      .then(goals => {
        goals.forEach(goal => {
          goal.startedOn = moment(goal.created_at).format('ll');
          if (goal.end_date) {
            goal.deadline = moment(goal.end_date).format('ll');
          }
        })
        this.goals = goals;
      }).finally(() => {
        this.loadingGoals = false;
      })
  },
  methods: {
    complete(goal) {
      this.goals = this.goals.filter(g => g !== goal);
    },
    refreshKPI() {
      axios
       .get(`${process.env.VUE_APP_API_URL}clients/kpis/chart_info/`)
       .then(({ data }) => {
         this.kpis = data;
       }).finally(() => {
         this.loadingKpi = false;
       })
    },
    destroyKPI(kpi) {
      dataStore.destroy("ClientKPI", kpi);
      this.kpis = this.kpis.filter(k => k.id !== kpi);
    },
    remove(goal) {
      goal.abandoned = true;
      goal.save();
      snackbar.update("Deleted");
      this.goals = this.goals.filter(g => g !== goal);
    },
    addGoal(goal) {
      if (!this.goals.includes(goal)) {
        this.goals = [goal, ...this.goals];
      }
      this.selectedGoal = { milestones: [], color: "" };
      this.editGoal = false;
      snackbar.update('Saved');
    },
    edit(goal) {
      this.selectedGoal = goal;
      this.editGoal = true;
    },

  }
};
</script>

<style lang="less" scoped>
</style>
